/***
 * Created on 2024/2/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React, {useEffect} from 'react';
import ModalDialog from "../../../../common/modal_dialog/modalDialog";
import QnapAuthAppStepContent from "./qnap_auth_app_step_content";
import {useTranslation} from "react-i18next";
import {useQnapAuthAppBindCheck} from "../../../../../hook/qnap_auth_app_bind_check";
import QnapAuthAppTimer from "./qnap_auth_app_timer";
import QnapAuthCheckStatus from "./qnap_auth_check_status";

function QnapAuthAppApproval({dispatch, state, ...props}) {
    const { t } = useTranslation();
    // const {status, device, passcode} = useQnapAuthAppBindCheck();

    const getTimerLeft = () => {
        let timer = sessionStorage.getItem('timer');
        timer = timer ? parseInt(timer) : 0;
        const current = new Date().getTime();
        const left = 300 - Math.round(current - timer) / 1000;
        return left;
    }

    const onBack = () => {
        dispatch({type: 'toggleShowInitQnapAuthAppSetup', value: true, method: null});
    }

    // useEffect(() => {
    //     if (status === 'valid') {
    //         dispatch({type: 'toggleShowSuccess', value: true, device});
    //     }
    // }, [status]);

    return (
        <ModalDialog {...props} title={t('@Verify through an app@')} hideSubmit={true} submitText={t('@Back@')} submitAction={onBack} withWizardMode={true} withStepBar={true} stepContent={() => QnapAuthAppStepContent({state, step: 3})} >
            <div className="dialog-content dialog-content--two-step">
                {/*倒數結束後回到上一步驟*/}
                <div className="two-step--verify">
                    <div className="two-step--verify__action">
                        <p className="!mb-16">{t('@Confirm the code below is shown on your mobile app@')}</p>
                        <div
                            className="dialog__info-grid flex-1 display-flex flex-direction-column align-items-center justify-content-center">
                            {/*<p className="two-step--verify__action__code !text-48 !line-height-normal">{passcode}</p>*/}
                            <QnapAuthCheckStatus dispatch={dispatch} state={state} showPassCode={true} enable={state.method === 'approval'}/>
                            {/*倒數 */}
                            <div className="two-step--verify__action__count-down">
                                <div className="two-step--verify__action__count-down__ic"></div>
                                <QnapAuthAppTimer init_time={getTimerLeft()}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ModalDialog>
    );
}

export default QnapAuthAppApproval;